import React, { ReactElement, ReactNode } from "react";
import { Stack } from "@mantine/core";
import styles from "./LabelValueStack.module.scss";

export function LabelValueStack({
  label,
  value,
  primary = false,
  primaryLabel = false,
  size = "md",
  bottomOffset = 0,
}: {
  label: string;
  value: string | number | ReactNode;
  primary: boolean;
  primaryLabel?: boolean;
  size?: "xl" | "lg" | "md" | "sm";
  bottomOffset?: number;
}): ReactElement | null {
  return (
    <Stack align={"start"} gap={5}>
      <span
        className={`${styles.topLabel} ${primaryLabel ? styles.primary : ""} ${styles[size]}`}
        style={{ position: "relative", bottom: `${bottomOffset}px` }}
      >
        {label}
      </span>
      <span
        className={`${styles.bottomLabel} ${primary ? styles.primary : ""} ${styles[size]}`}
      >
        {value}
      </span>
    </Stack>
  );
}
